function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch {
        return {};
    }
}

const state = {
    user_logged: false,
    email: null,
    user_data: null,
    access_token: null,
    role: null,
};

const mutations = {
    SET_CLIENT_INFO(state, { email, user_data, access_token, role }) {
        state.user_logged = true;
        state.email = email;
        state.user_data = user_data;
        state.access_token = access_token;
        state.role = role;
    },
    ERASE_CLIENT_INFO(state) {
        state.user_logged = false;
        state.email = null;
        state.user_data = null;
        state.access_token = null;
        state.role = null;
    },
};

const getters = {
    get_client_data(state) {
        return state;
    },
    get_role(state) {
        return state.role;
    },
};

const actions = {
    async login({ commit }, { email, password, cnpj, rememberMe = false }) {
        const { ct_clients } = await import('@/controllers/clients');

        const response = await ct_clients.signIn({ email, password, cnpj, rememberMe });
        if (!response.status) throw response.error;

        const profile = await ct_clients.getProfile(response.access_token);
        if (!profile.status) throw profile.error;

        const { role } = parseJwt(response.access_token);

        commit('SET_CLIENT_INFO', {
            email,
            user_data: profile.data,
            access_token: response.access_token,
            role: role || 'collaborator',
        });
    },

    logout({ commit }) {
        commit('ERASE_CLIENT_INFO');
        commit('clients_account/RESET_CLIENT_ACCOUNT_STATE', null, { root: true });
    },
};

const clients_users = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};

export default clients_users;
